import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { DeleteUserStore } from 'stores/users/DeleteUserStore';

type DeleteUserProps = {
  deleteUserStore: DeleteUserStore;
};

const DeleteUser = observer(({ deleteUserStore }: DeleteUserProps) => {
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const { deleteUser } = deleteUserStore;

  const handleDeleteClick = () => () => {
    setConfirmDeleteVisible(false);
    deleteUser();
  };

  return (
    <>
      <Stack spacing={4}>
        <Stack spacing={1}>
          <Typography variant="h5">
            <strong>Delete Account</strong>
          </Typography>
          <Typography variant="body1">Permanently delete your account and remove access from data.</Typography>
        </Stack>

        <Button
          color="error"
          variant="outlined"
          disableElevation
          style={{ height: 56 }}
          onClick={() => setConfirmDeleteVisible(true)}
        >
          Delete Account
        </Button>
      </Stack>

      {confirmDeleteVisible && (
        <Dialog open onClose={() => setConfirmDeleteVisible(false)} aria-label="confirm delete">
          <DialogContent>
            <DialogContentText>Delete your account? All your account data will be removed.</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={() => setConfirmDeleteVisible(false)}>
              Cancel
            </Button>
            <Button onClick={handleDeleteClick()}>Delete</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
});

export { DeleteUser };
